import { render, staticRenderFns } from "./SmallTopicWithIcon.vue?vue&type=template&id=29eba3b0&"
import script from "./SmallTopicWithIcon.vue?vue&type=script&lang=ts&"
export * from "./SmallTopicWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SmallTopicWithIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VIcon,VRow,VSheet})
